import Login from "../features/Login";
import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { useModal } from "../context.js/ModalContext";
import { useSelector } from "react-redux";

const ProtectedRoute = () => {
	const { isAuthenticated } = useSelector((state) => state.userDetails);
	const { openLoginModal } = useModal();

	useEffect(() => {
		if (!isAuthenticated) {
			//logger.log("User not authenticated, opening login modal...");

			openLoginModal();
		}
	}, [isAuthenticated, openLoginModal]);

	return isAuthenticated ? <Outlet /> : null; // Prevent rendering if not authenticated
};

export default ProtectedRoute;
